import React from 'react';
import classNames from 'classnames';
import type { Row } from 'react-table';

interface IGroupedRow<T extends {}> {
	row: Row<T>;
	rowIndex?: number;
	style?: React.CSSProperties;
	isSticky?: boolean;
	onExpand?: () => void;
	onSelect?: (runsIds: number[], checked: boolean) => void;
}

export const GROUP_CLASS_NAME = 'table-group-row';

const GroupedRow = <T extends Record<string, unknown>>(props: IGroupedRow<T>) => {
	const { row, rowIndex, style, isSticky, onExpand, onSelect } = props;
	const { onClick } = row.getToggleRowExpandedProps();
	const cell = row.allCells.find(cell => cell.isGrouped === true);

	const handleRowClick = () => {
		if (onExpand) {
			onExpand();
		}

		onClick();
	};

	return (
		<div
			{...row.getRowProps({ style })}
			className={classNames(GROUP_CLASS_NAME, { sticky: isSticky })}
			onClick={handleRowClick}
			data-row-index={rowIndex}
			data-row-expanded={row.isExpanded}
			data-group-by={row.groupByID}
		>
			{cell.render('Group', { onSelect })}
		</div>
	);
};

export default GroupedRow;
